module.exports = __webpack_public_path__ + "img/800_5a15ab3119d59.03b508c2.jpg";